import { useReactiveVar } from '@apollo/client'
import { Button, Flex, Text } from '@radix-ui/themes'
import { isPrivyReadyVar } from 'features/auth-privy/store'
import { DataTestIDs } from 'shared/constants'
import { exportPrivyKey } from '../utils/wallet-actions'

/** Privy only (FE-304): the embedded wallet's key leaves through Privy's own modal. */
export const PrivyExportSection: React.FC = () => {
  const isPrivyReady = useReactiveVar(isPrivyReadyVar)

  return (
    <Flex
      direction='column'
      gap='2'
    >
      <Text
        size='2'
        color='gray'
      >
        The primary wallet was created by Privy when you signed up. Its private
        key can be exported in Privy&apos;s own window; it never reaches XYRO.
      </Text>
      <Flex>
        <Button
          variant='soft'
          type='button'
          disabled={!isPrivyReady}
          onClick={() => void exportPrivyKey()}
          data-testid={DataTestIDs.buttonPrivyWalletExport}
        >
          Export embedded key
        </Button>
      </Flex>
    </Flex>
  )
}
